module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/File-plus-7a98d07dd711c70698b7bbbe1b2aab44.svg";